
    import Map from 'ol/Map.js';
    import OSM from 'ol/source/OSM.js';
    import STAC from 'ol-stac';
    import { getStacObjectsForEvent } from 'ol-stac/util.js';
    import TileLayer from 'ol/layer/WebGLTile.js';
    import View from 'ol/View.js';
    import proj4 from 'proj4';
    import { register } from 'ol/proj/proj4.js';

    register(proj4); // required to support source reprojection
    const root = 'https://maxar-opendata.s3.amazonaws.com/events/WildFires-LosAngeles-Jan-2025/ard';
    const collectionURL = 'https://maxar-opendata.s3.amazonaws.com/events/WildFires-LosAngeles-Jan-2025/collection.json';
    const background = new TileLayer({
      source: new OSM(),
    });


    async function getData() {

      const url = "https://maxar-opendata.s3.amazonaws.com/events/WildFires-LosAngeles-Jan-2025/collection.json";
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const json = await response.json();
      //console.log(json);
      let links = json.links;
      let results = [];
      let x = await links.map(async (l) => {
        if (l.rel == 'child') {
          const child = await fetch(new URL(l.href, root));
          let childJson = await child.json();
          let temporal = childJson.extent.temporal;
          //console.log(childJson);
          let r = { 'relURL': l.href, 'temporal': temporal, 'numLinks': childJson.links.length };
          results.push(r);
          return r;
        }

      });
      let y = await Promise.all(x);
      y = y.filter((x) => x);
      y.sort((a, b) => new Date(a.temporal.interval[0][0]) - new Date(b.temporal.interval[0][0]));
      let mapId = 0;
      let maps = []
      y.forEach((r) => {
        mapId++;
        let collURL = new URL(r.relURL, url);
        document.getElementById('foo').innerHTML += (`<div>${new Date(r.temporal.interval[0][0])}<br><a target="_blank" href="view_collection.html?collection_url=${encodeURIComponent(collURL)}">${r.relURL}</a><br>${r.numLinks} links<p></div>`);
        document.getElementById('foo').innerHTML += (`<div>${collURL}</div>`);
        document.getElementById('foo').innerHTML += (`<div id="m${mapId}" style="width: 400px; height: 0px"></div>`);
        maps.push(new Map({
          target: `m${mapId}`,
          layers: [
            new TileLayer({
              source: new OSM(),
            })/*,new STAC({ url: collURL })*/],
          view: new View({ center: [0, 0], zoom: 10 })
        }
        ));
      });
      //mapId=0
      //y.forEach((r) => {
      //  mapId++;
      //  let collURL = new URL(r.relURL, url);
      //  maps.push(new Map({
      //    target: `m${mapId}`,
      //    layers: [
      //      new TileLayer({
      //        source: new OSM(),
      //      })/*,new STAC({ url: collURL })*/],
      //    view: new View({ center: [0, 0], zoom: 10 })
      //  }
      //  ));
      //});


      //console.log('y', y);
      const stacCollection = new STAC({
        url: collectionURL
      });
      //const map = new Map({
      //  target: 'map',
      //  layers: [background, stacCollection],
      //  view: new View({
      //    center: [0, 0],
      //    zoom: 0,
      //  }),
      //});

      stacCollection.on('sourceready', () => {
        //console.log('feh');
        const view = map.getView();
        view.fit(stacCollection.getExtent(), { maxZoom: 12 });
      });
      //      map.on('singleclick', async (event) => {
      //        console.log('click', stacCollection.getData());
      //        const objects = await getStacObjectsForEvent(event, stacCollection.getData());
      //        if (objects.length > 0) {
      //          console.log(objects);
      //          const ids = objects.map((obj) => obj.id);
      //          document.getElementById('ids').innerText = ids.join(', ');
      //        } else {
      //          console.log('no objects');
      //        }
      //      });

      return results;

    }

    let results = await getData();
  